/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ExternalDocumentSubTypeDto } from '../../models/external-document-sub-type-dto';

export interface GetAllDocumentSubTypes$Params {
}

export function getAllDocumentSubTypes(http: HttpClient, rootUrl: string, params?: GetAllDocumentSubTypes$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ExternalDocumentSubTypeDto>>> {
  const rb = new RequestBuilder(rootUrl, getAllDocumentSubTypes.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ExternalDocumentSubTypeDto>>;
    })
  );
}

getAllDocumentSubTypes.PATH = '/external-document/sub-types/all';
